import { PaymentModuleId } from '@foundation/apis/payments';
import { SupportedLanguage } from '@foundation/localization';

import { registerStartupable } from '@/services/base/StartupHelper';

import { OptionalStartupable } from '../base/Startupable';
import PaymentStore from '../payments/PaymentStore';
import { getTransbankUrl } from './helpers/TransbankApi';

interface ParamsUsedInRequest {
  readonly paymentIntentId: string;
  readonly locale: string;
  readonly telemetryConsent: boolean;
}

class TransbankService implements OptionalStartupable {
  public readonly name = 'TransbankService';
  public readonly moduleId = PaymentModuleId.Transbank;

  private dataUsedForRequest: ParamsUsedInRequest | undefined;
  private redirectUrl: string | undefined;

  constructor() {
    registerStartupable(this, [PaymentStore]);
  }

  public startup(): Promise<void> {
    return Promise.resolve();
  }

  public shouldStart(): boolean {
    return PaymentStore.allowedPaymentModules.includes(this.moduleId);
  }

  public getRedirectUrl(
    locale: SupportedLanguage,
    accessToken: string,
    telemetryConsent = false,
  ): Promise<string> {
    const paymentIntentId = PaymentStore.paymentIntentId;

    if (
      this.shouldReturnCachedUrl(paymentIntentId, locale, telemetryConsent) &&
      this.redirectUrl
    ) {
      return Promise.resolve(this.redirectUrl);
    }

    return getTransbankUrl(
      paymentIntentId,
      accessToken,
      locale,
      telemetryConsent,
    ).then((url) => {
      this.redirectUrl = url;
      this.dataUsedForRequest = {
        paymentIntentId,
        locale,
        telemetryConsent,
      };

      return this.redirectUrl;
    });
  }

  private shouldReturnCachedUrl(
    paymentIntentId: string,
    locale: SupportedLanguage,
    telemetryConsent: boolean,
  ) {
    return (
      this.dataUsedForRequest &&
      this.dataUsedForRequest.paymentIntentId === paymentIntentId &&
      this.dataUsedForRequest.locale === locale &&
      this.dataUsedForRequest.telemetryConsent === telemetryConsent
    );
  }
}

export default new TransbankService();
